<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
          <div class="col-md-12">
            <div class="card">
              <div class="card-body">
                <div class="col-md-12 mb-3">
                    <div class="box-horizontal">
                      <div style="cursor:pointer" @click="$router.go(-1)">
                        <i class="p-2 material-icons text-info">arrow_back</i>
                      </div>
                      <div style="flex:1">
                        <h3 class="mt-0 text-right">Detail</h3>
                      </div>
                    </div>
                    <div class="postingan">
                      <div class="header mb-1">
                        <div class="box-horizontal">
                          <div class="logo">
                            <div class="logo" :style="{ backgroundImage: 'url(' + data.params.icon + ')' }"></div>
                          </div>
                          <div class="nama">
                            <h5 class="mb-0 text-info">{{data.params.nama}}</h5>
                            <small class="text-secondary">{{data.params.jam}} - {{data.params.tanggal}}</small>
                          </div>
                        </div>
                      </div>
                      <div class="content">
                        <p v-html="myGlobal.newline(data.params.teks)"></p>
                        <div v-if="data.params.link != null" class="alert alert-info" role="alert">
                          {{data.params.link}}
                        </div>
                        <img v-if="data.params.gambar != null" style="max-width:600px;max-height:400px" class="mb-2" :src="myGlobal.ForumAssets() + 'images/postingan/' + data.params.gambar" alt="gambar postingan">
                      </div>
                    </div> 
                    <div class="komen" v-for="(u, index) in theGet.data.komen">
                      <div class="box-horizontal" style="margin-bottom: 0">
                          <div class="nama" style="flex:1">
                            <p class="mb-0 text-info">{{u.nama}}  <small class="text-secondary">pada {{u.jam}} - {{myGlobal.tglIndo(u.tanggal)}}</small></p>
                            <p v-html="myGlobal.newline(u.teks)">{{u.teks}}</p>
                          </div>
                          <div class="logo">
                            <div  class="logo" :style="{ backgroundImage: 'url(' + u.icon + ')' }"></div>
                          </div>
                      </div>
                    </div>
                    <div class="komen-box">
                        <div class="input-group">
                          <textarea rows="3" class="form-control" placeholder="Yuk Ikut Rundingan..." v-model="post.datax.teks"></textarea>
                          <div class="input-group-append">
                              <button class="btn btn-sm btn-outline-danger" type="button" @click="post.komen()">Kirim</button>
                          </div>
                        </div>
                    </div>
                </div>
              </div>
            </div>
          </div>
          
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'

import { reactive, watch  } from '@vue/composition-api'
import myGlobal from '@/globalFunc/myGlobal' 
import inter from '@/globalFunc/Interface' 
import Loading from '@/globalFunc/Loading' 

export default {
    components: { 
        'Loading': Loading
    }, 
    
  //methods: {
    setup() {
      const data = reactive({
        params: ''
      })

      const post = {
        datax: reactive({
          id: '',
          teks: ''
        }),
        komen() {
          //console.log(sessionStorage.getItem('admin'));
          var datax = {
              token: 'TangTung '+sessionStorage.getItem('myToken'),
              teks: this.datax.teks.replace(/\n/g,'\\n'),
              id: this.datax.id
          };
      
          var apiUrl = inter.ForumKomenPost();
          myGlobal.callForum(datax,apiUrl).then(x => {
              if (x.status == true) {
                  theGet.datae();
                  this.datax.teks = ""
              } else {
                //alert(x.pesan);
              }
          })
        }
      }

      const theGet = {
        data: reactive({
          komen: ''
        }),
        datae() {
          //console.log(sessionStorage.getItem('admin'));
          var datax = {
              token: 'TangTung '+sessionStorage.getItem('myToken'),
              id: post.datax.id
          };
      
          var apiUrl = inter.ForumKomen();
          myGlobal.callForum(datax,apiUrl).then(x => {
              if (x.status == true) {
                this.data.komen = x.data;
              } else {
                //alert(x.pesan);
              }
          })
        },
        detail(id) {
          alert(id);
        }
      }
      
      return {
        data,
        post,
        theGet,
        myGlobal
      }

    },
    mounted () {
      document.title = "Detail Postingan";
      
      this.post.datax.id = this.$route.params.pid;

      this.data.params = this.$route.params;

      this.theGet.datae();
    }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.modal {
	display: inherit;
}
.logo {
  height:50px;width:50px;
  background-size: auto 100% ;
  border-radius: 100%;
  margin-right: 20px;
}
.postingan {
  display: block;
  margin-bottom: 10px;
  padding: 10px;
}

.komen {
  display: block;
  padding: 10px;
  border-bottom: 1px solid #aeaeae;
}
.komen:last-child {
  border: 0px;
}

.komen-box {
  margin-top: 30px;
  padding: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/forum/detail.vue